import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "toggle"]
  static values  = { open: { type: Boolean, default: false } }

  connect () {
    if (this.contentTarget.scrollHeight > this.contentTarget.offsetHeight) {
      this.toggleTarget.hidden = false
    }
  }

  toggle (event) {
    event.preventDefault()
    this.openValue = !this.openValue
  }

  openValueChanged () {
    this.element.classList.toggle("line-clamp--open", this.openValue)
    this.toggleTarget.textContent = this.openValue ? "weniger anzeigen" : "mehr anzeigen"
  }
}
